import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { I18NextModule } from 'angular-i18next';
import { ButtonModule, MbsSize, ModalComponent, ModalModule } from 'mbs-ui-kit';
import { RecoveryCodeComponent } from 'mbs-ui-shared@components';

@Component({
  selector: 'mbs-recovery-code-modal',
  templateUrl: './recovery-code-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ModalModule, ButtonModule, I18NextModule, RecoveryCodeComponent]
})
export class RecoveryCodeModalComponent {
  public codes: Array<string>;
  public isSavedRecoveryCodes = false;

  public MbsSize = MbsSize;

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;
}
